import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';
import useDebounce from '../hooks/useDebounce';

const SearchInput = ({ placeholder, onChange, value, className, style, debounceTime = 600 }) => {
  const [localValue, setLocalValue] = useState(value || '');
  const debouncedValue = useDebounce(localValue, debounceTime);

  const lastSentValue = useRef(value || '');

  // Sync external value to local state (e.g., initial load or manual clear by parent)
  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value || '');
      lastSentValue.current = value || '';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  // Trigger main onChange when debounced value changes
  useEffect(() => {
    const trimmedValue = debouncedValue?.trim() || '';
    if (trimmedValue !== lastSentValue.current) {
      lastSentValue.current = trimmedValue;
      onChange(trimmedValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue, onChange]);

  const handleClear = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (e && e.preventDefault) e.preventDefault();
    setLocalValue('');
  };

  return (
    <div className={`common-search-input-wrapper position-relative ${className}`} style={{ ...style }}>
      <input
        type="text"
        placeholder={placeholder || 'Search...'}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        className="common-search-input"
        aria-label={placeholder || 'Search input'}
        maxLength={255}
        autoComplete="off"
      />
      {localValue && (
        <FaTimes
          className="position-absolute"
          onClick={handleClear}
          style={{
            right: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#adb5bd',
            fontSize: '14px',
            zIndex: 4,
            cursor: 'pointer'
          }}
          aria-label="Clear search"
        />
      )}
    </div>
  );
};

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  debounceTime: PropTypes.number
};

export default SearchInput;
